import { styled } from 'styled-components';
import { Card, Row, Col } from '@packages/utils';
import { Image } from 'components/Base/Image';

export const SSelectableImageWrapper = styled(Col)`
  max-width: 120px;
  margin-right: 12px;
  position: relative;

  &.selected {
    .ant-card {
      border: 3px solid #0077a0;
    }

    .selected-wrapper {
      display: flex;
      background-color: #0077a0;
      width: 26px;
      height: 26px;
      top: 6px;
      right: 0;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: 2px solid white;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

      .anticon {
        font-size: 10px;
      }

      svg {
        width: 10px;
        height: 10px;
      }
    }
  }
`;

export const SImageWrapper = styled(Card)`
  width: 120px;
  height: 120px;
`;

export const SSelectedPhotoHoverWrapper = styled(Row)`
  position: absolute;
  display: none;
  cursor: pointer;
`;

export const SImage = styled(Image)``;
